import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface JobContentProps {
  children: ReactNode;
  className?: string;
}

export const JobContent: React.FC<JobContentProps> = ({ 
  children,
  className = ''
}) => {
  return (
    <motion.section 
      className="relative overflow-hidden py-16 bg-gray-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="page-padding">
        <div className="container-medium">
          <div className={`prose prose-lg max-w-none text-dark-700 leading-relaxed ${className}`}>
            {children}
          </div>
        </div>
      </div>
    </motion.section>
  );
};
